import React from 'react';
import { FieldSortOrder, WorkbookFieldsByIdDocument, WorkbookFieldsByIdFieldsConnectionFragment, WorkbookFieldsByIdQuery, WorkbookFieldsByIdQueryVariables } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper,
  SelectionProviderChildProps,
} from '../../../data-catalog-shared';

import { iconForField } from '../field/functions/FieldFunctions';
import { FieldsValidSortFields } from '../sorting/sortProviders/FieldsGridSortProvider';
import { WorkbookFieldsDisplayGrid, WorkbookFieldsDisplayGridRowData } from './WorkbookFieldsDisplayGrid';

export type QueryVariables = WorkbookFieldsByIdQueryVariables;
export type QueryResults = WorkbookFieldsByIdQuery;
export type QueryResultListNode = WorkbookFieldsByIdFieldsConnectionFragment;
export type GridRowData = WorkbookFieldsDisplayGridRowData;

export type WorkbookFieldsQueryGridProps =
  SelectionProviderChildProps &
  GridSortProps<FieldsValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly selectedEmbeddedDatasourceId: string;
    readonly rowCount: number | null;
  };

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.workbooks && resultData.workbooks[0] &&
    resultData.workbooks[0].embeddedDatasources[0] && resultData.workbooks[0].embeddedDatasources[0].fieldsConnection;
}

function mapResultNode(field: QueryResultListNode, resultData: QueryResults): GridRowData {
  const dataType = 'dataType' in field ? field.dataType : null;

  return {
    ...field,
    dataType,
    workbookId: resultData.workbooks[0].vizportalUrlId,
    fieldIcon: iconForField(field),
    sheetCount: field.downstreamSheetsConnection ? field.downstreamSheetsConnection.totalCount : null,
    labels: field.__typename === 'ColumnField' || field.__typename === 'DatasourceField'? 
      field.columnsConnection?.nodes.flatMap(t => t.labels, []) : [],
  };
}


export function WorkbookFieldsQueryGrid(props: WorkbookFieldsQueryGridProps): JSX.Element {

  return (
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={WorkbookFieldsByIdDocument}
      partialQueryVariables={{
        workbookVizportalUrlId: props.vizportalUrlId,
        selectedEmbeddedDatasourceId: props.selectedEmbeddedDatasourceId,
        orderBy: props.orderBy as FieldSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={mapResultNode}
    >
      {({ rowStore }) => (
        <WorkbookFieldsDisplayGrid
          rowStore={rowStore}
          selectedKeys={props.selectedKeys}
          updateSelectionForKey={props.updateSelectionForKey}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      )}
    </PaginatedQueryWrapper>
  );

}

